import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from "axios";
import { baseUrl } from './config';
import Cookies from 'js-cookie';

export const insertTransaction = createAsyncThunk(
    '/insertTransaction',
    async (data) => {
        let url = baseUrl+'insertTransaction';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
   
        if(response.status === "success"){
            return Promise.resolve(response)
        } else if(response.status ==="error") {
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );


  export const insertRequest = createAsyncThunk(
    '/insertRequest',
    async (data) => {
        let url = baseUrl+'insertrequest';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
   
        if(response.status === "success"){
            return Promise.resolve(response)
        } else if(response.status ==="error") {
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );


  export const GetTransaction = createAsyncThunk(
    '/GetTransaction',
    async (data) => {
        let url = baseUrl+'getTransaction';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
      
        if(response.status === "success"){

            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );


  export const GetReceveidRequest = createAsyncThunk(
    '/GetReceveidRequest',
    async (data) => {
        let url = baseUrl+'Getrequests';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
      
        if(response.status === "success"){

            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );



  


  